import axios from "axios";
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
//import { fetchAsset } from "./helpers";

export const reportMixin = {
  methods: {
    getRequestConfig() {
      return {
        headers: {
          Token: this.$store.state.token,
          "Cache-Control": "no-cache",
        },
      };
    },

    async generateReport() {
      try {
        this.loading = true;
        const response = await axios.post(
          "viaje/report",
          this.formData,
          this.getRequestConfig(),
        );
        this.report = response.data;
        this.showSnackbar("Reporte generado con éxito", "success");
      } catch (error) {
        this.handleError("Error generando reporte:", error);
      } finally {
        this.loading = false;
      }
    },

    calculateTotalTickets(tickets = []) {
      return tickets.reduce((sum, ticket) => sum + (ticket.total || 0), 0);
    },

    getTripType(item) {
      if (item.viaje_nacionals?.length > 0) {
        return (
          item.viaje_nacionals[0].region_nacional_region_nacional?.nombre || ""
        );
      }
      if (item.viaje_internacionals?.length > 0) {
        return (
          item.viaje_internacionals[0].region_internacional_region_internacional
            ?.nombre || ""
        );
      }
      return "";
    },

    async exportToExcel() {
      try {
        this.loading = true;

        const title = "REPORTE DE VIÁTICOS";
        const headers = [
          "N°",
          "Autorización",
          "Nombre",
          "Cargo",
          "Programa",
          "Lugar",
          "Transporte",
          "Fecha Ida",
          "Fecha Retorno",
          "Tipo Viaje",
          "Resolución",
          "Días",
          "Estado",
          "Viáticos",
          "Pasajes",
        ];

        // 2. Preparar los datos
        const excelData = [];

        // Fila vacía para el título (se llenará después)
        excelData.push([title]);

        // Fila vacía para separación
        excelData.push([]);

        // Añadir encabezados
        excelData.push(headers);

        // Añadir datos
        this.processedReport.forEach((item, index) => {
          // Fila principal
          const mainRow = [
            index + 1,
            item.cite,
            item.userName,
            item.userPosition,
            item.unitDescription,
            item.location,
            item.transportName,
            this.formatDateExcel(item.startDate),
            this.formatDateExcel(item.endDate),
            item.tripType,
            item.resolution,
            item.days,
            item.state,
            item.totalAllowance,
            item.totalTickets,
          ];
          excelData.push(mainRow);

          // Fila de motivo
          const motivoRow = new Array(headers.length).fill("");
          motivoRow[0] = "Motivo: " + item.motive;
          excelData.push(motivoRow);
        });

        // 3. Crear el libro y hoja de trabajo
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);

        // 4. Configurar dimensiones de columnas
        const wscols = [
          { wch: 5 },
          { wch: 15 },
          { wch: 25 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 15 },
          { wch: 20 },
          { wch: 8 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
        ];
        worksheet["!cols"] = wscols;

        // 5. Configurar combinaciones de celdas
        const merges = [
          // Combinación para el título (A1:O1)
          { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
        ];

        // Combinaciones para los motivos
        let rowIndex = 3; // Empieza después de título vacío y encabezados
        this.processedReport.forEach(() => {
          merges.push({
            s: { r: rowIndex + 1, c: 0 },
            e: { r: rowIndex + 1, c: headers.length - 3 },
          });
          rowIndex += 2;
        });
        worksheet["!merges"] = merges;

        // 6. Aplicar estilos
        // Definir estilos primero
        const titleStyle = {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "center", vertical: "center" },
          fill: { fgColor: { rgb: "D9D9D9" } },
        };

        const headerStyle = {
          font: { bold: true },
          alignment: { horizontal: "center" },
          fill: { fgColor: { rgb: "F2F2F2" } },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };

        const cellStyle = {
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };

        // Aplicar estilo al título
        const titleCell = "A1";
        if (!worksheet[titleCell]) worksheet[titleCell] = {};
        worksheet[titleCell].v = title;
        worksheet[titleCell].t = "s";
        worksheet[titleCell].s = titleStyle;

        // Aplicar estilos a todas las celdas
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let R = range.s.r; R <= range.e.r; ++R) {
          for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

            // Inicializar celda si no existe
            if (!worksheet[cellAddress]) {
              worksheet[cellAddress] = { v: "", t: "s" };
            }

            // Aplicar estilo según el tipo de celda
            if (R === 2) {
              // Fila de encabezados (tercera fila)
              worksheet[cellAddress].s = headerStyle;
            } else if (R > 2) {
              // Celdas de datos
              worksheet[cellAddress].s = cellStyle;
            }
          }
        }

        // 7. Finalizar el archivo
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte de Viajes");
        XLSX.writeFile(
          workbook,
          `Reporte_Viajes_${this.getFormattedDate()}.xlsx`,
        );

        this.showSnackbar("Exportación a Excel completada", "success");
      } catch (error) {
        console.error("Error detallado:", error);
        this.handleError("Error al exportar a Excel:", error);
      } finally {
        this.loading = false;
      }
    },

    async exportToPDF() {
      try {
        this.loading = true;
        const pdfDoc = await PDFDocument.create();
        pdfDoc.registerFontkit(fontkit);
        const pageWidth = 792;
        const pageHeight = 612;
        const margin = { left: 40, right: 40, top: 65, bottom: 55 };
        const availableWidth = pageWidth - margin.left - margin.right;

        const [font, image] = await Promise.all([
          pdfDoc.embedFont(StandardFonts.Helvetica),
          pdfDoc.embedPng(await this.fetchAsset(`membreteLat.png`)),
        ]);
        const boldFont = await pdfDoc.embedFont(
          await (
            await fetch(require(`@/assets/fonts/verdana-bold-bold.ttf`))
          ).arrayBuffer(),
        );

        const columns = [
          {
            key: "index",
            header: "N°",
            width: 40,
            align: "center",
          },
          {
            key: "cite",
            header: "AUTORIZACIÓN",
            width: 95,
            align: "center",
          },
          { key: "name", header: "NOMBRE", width: 120, align: "center" },
          { key: "program", header: "PROGRAMA", width: 100, align: "center" },
          {
            key: "location",
            header: "LUGAR/TRANSPORTE",
            width: 110,
            align: "center",
          },
          {
            key: "dates",
            header: `FECHAS\nIDA/VUELTA`,
            width: 80,
            align: "center",
          },
          { key: "days", header: "DÍAS", width: 40, align: "center" },
          {
            key: "status",
            header: "ESTADO",
            width: 70,
            align: "center",
          },
          { key: "allowance", header: "VIÁTICOS", width: 70, align: "center" },
          { key: "tickets", header: "PASAJES", width: 70, align: "center" },
        ];

        // 4. Verificar que la tabla cabe en la página
        const tableWidth = columns.reduce((sum, col) => sum + col.width, 0);
        if (tableWidth > availableWidth) {
          const scaleFactor = availableWidth / tableWidth;
          columns.forEach((col) => (col.width *= scaleFactor));
        }

        // 5. Configuración de estilos
        const styles = {
          title: { size: 16, color: rgb(0, 0, 0) },
          header: {
            fill: rgb(0.16, 0.5, 0.72),
            text: { size: 7, color: rgb(1, 1, 1) },
            height: 25,
          },
          row: {
            height: 0,
            evenFill: rgb(0.98, 0.98, 0.98),
            text: { size: 7, color: rgb(0, 0, 0) },
            padding: 4,
            wrap: true,
          },
          motive: {
            minHeight: 20,
            fill: rgb(0.95, 0.95, 0.95),
            text: { size: 7, color: rgb(0.3, 0.3, 0.3) },
            maxLines: 4, // Máximo de líneas para el motivo
          },
          border: { color: rgb(0.8, 0.8, 0.8), width: 0.5 },
        };

        // 6. Función para añadir página
        const addPage = () => {
          const page = pdfDoc.addPage([pageWidth, pageHeight]);
          if (image) {
            page.drawImage(image, {
              x: 0,
              y: 0,
              width: pageWidth,
              height: pageHeight,
              opacity: 0.9,
            });
          }
          return page;
        };

        // 7. Función mejorada para dibujar celdas
        const drawCell = (page, text, x, y, width, height, options = {}) => {
          const {
            align = "left",
            valign = "middle",
            fillColor,
            border = true,
            textSize = styles.row.text.size,
            textColor = styles.row.text.color,
            padding = styles.row.padding,
            isMotive = false,
            font: cellFont = font,
          } = options;

          // Dibujar fondo de celda
          if (fillColor) {
            page.drawRectangle({
              x,
              y: y - height,
              width,
              height,
              color: fillColor,
              borderWidth: 0,
            });
          }

          // Dibujar bordes
          if (border) {
            page.drawRectangle({
              x,
              y: y - height,
              width,
              height,
              borderColor: styles.border.color,
              borderWidth: styles.border.width,
            });
          }

          // Procesar texto para múltiples líneas
          let textLines = [];
          const maxTextWidth = width - 2 * padding;
          const lineHeight = textSize + 2;

          (text?.toString() || "").split("\n").forEach((line) => {
            let currentLine = "";
            line.split(" ").forEach((word) => {
              const testLine = currentLine ? `${currentLine} ${word}` : word;
              const testWidth = font.widthOfTextAtSize(
                testLine
                  .toString()
                  .replace(/[\u0000-\u001F]/g, " ")
                  .trim(),
                textSize,
              );

              if (testWidth > maxTextWidth && currentLine) {
                textLines.push(currentLine);
                currentLine = word;
              } else {
                currentLine = testLine;
              }
            });
            if (currentLine) textLines.push(currentLine);
          });

          // Manejar truncamiento para motivos largos
          if (isMotive && textLines.length > styles.motive.maxLines) {
            textLines = textLines.slice(0, styles.motive.maxLines);
            textLines[textLines.length - 1] =
              textLines[textLines.length - 1].slice(0, -3) + "...";
          }

          // Calcular posición Y inicial
          let textY = y;
          if (valign === "middle") {
            textY =
              y - height / 2 + (textLines.length * lineHeight) / 2 - textSize;
          } else if (valign === "top") {
            textY = y - padding - textSize;
          } else {
            // bottom
            textY = y - height + textLines.length * lineHeight + padding;
          }

          // Dibujar cada línea de texto
          textLines.forEach((line, i) => {
            let textX = x + padding;
            const textWidth = font.widthOfTextAtSize(
              line
                .toString()
                .replace(/[\u0000-\u001F]/g, " ")
                .trim(),
              textSize,
            );

            if (align === "right") {
              textX = x + width - textWidth - padding;
            } else if (align === "center") {
              textX = x + (width - textWidth) / 2;
            }

            page.drawText(line, {
              x: textX,
              y: textY - i * lineHeight,
              size: textSize,
              font: cellFont,
              color: textColor,
              maxWidth: maxTextWidth,
            });
          });
        };

        // 8. Generar contenido del PDF
        let page = addPage();
        let y = pageHeight - margin.top - 40;

        // Dibujar título
        page.drawText("REPORTE DE VIÁTICOS", {
          x: margin.left + 250,
          y,
          size: styles.title.size,
          font: boldFont,
          color: styles.title.color,
        });
        y -= 30;

        // Dibujar cabeceras de tabla
        let x = margin.left;
        columns.forEach((col) => {
          drawCell(page, col.header, x, y, col.width, styles.header.height, {
            align: col.align,
            fillColor: styles.header.fill,
            textSize: styles.header.text.size,
            textColor: styles.header.text.color,
            font: boldFont,
          });
          x += col.width;
        });
        y -= styles.header.height;

        // Dibujar filas de datos
        const totalAllowance = this.processedReport.reduce(
          (sum, item) => sum + (item.totalAllowance || 0),
          0,
        );
        const totalTickets = this.processedReport.reduce(
          (sum, item) => sum + (item.totalTickets || 0),
          0,
        );
        this.processedReport.forEach((item, index) => {
          const rowData = {
            index: (index + 1).toString(),
            cite: item.cite || "N/A",
            name: `${item.userName || "N/A"}\n${
              item.userPosition || ""
            }`.toUpperCase(),
            program: item.unitDescription || "N/A",
            location: `${item.location || "N/A"}\n${item.transportName || ""}`,
            dates: `${this.formatDatePdf(item.startDate)}\n${this.formatDatePdf(
              item.endDate,
            )}`,
            days: item.days?.toString() || "0",
            status: item.state || "N/A",
            allowance: item.totalAllowance
              ? `Bs. ${item.totalAllowance.toFixed(2)}`
              : "Bs. 0.00",
            tickets: item.totalTickets
              ? `Bs. ${item.totalTickets.toFixed(2)}`
              : "Bs. 0.00",
          };

          // Calcular altura necesaria para esta fila
          let rowHeight = styles.row.height;
          columns.forEach((col) => {
            const lines = rowData[col.key].split("\n").length;
            const textSize = col.size || styles.row.text.size;
            rowHeight = Math.max(
              rowHeight + 1,
              lines * (textSize + 2) + 2 * styles.row.padding,
            );
          });

          // Verificar espacio para nueva página
          if (y < margin.bottom + rowHeight + styles.motive.minHeight) {
            page = addPage();
            y = pageHeight - margin.top - 20;
          }

          // Dibujar fila
          x = margin.left;
          columns.forEach((col) => {
            console.log(col.key);
            if (col.key === "cite") col.align = "left";
            if (col.key === "allowance" || col.key === "tickets")
              col.align = "right";
            drawCell(page, rowData[col.key], x, y, col.width, rowHeight, {
              align: col.align,
              size: col.size,
              fillColor: index % 2 === 0 ? styles.row.evenFill : undefined,
              textSize: col.size || styles.row.text.size,
              textColor: styles.row.text.color,
            });
            x += col.width;
          });
          y -= rowHeight;

          // Dibujar fila de motivo con altura dinámica
          const motiveText = `MOTIVO: ${
            item.motive || "Sin motivo especificado"
          }`;
          const lineHeight = styles.motive.text.size + 2;
          let motive = motiveText
            .toString()
            .replace(/[\u0000-\u001F]/g, " ")
            .trim();
          const estimatedLines = Math.ceil(
            font.widthOfTextAtSize(motive, styles.motive.text.size) /
              (tableWidth - 2 * styles.row.padding),
          );
          const maxMotiveHeight = y - margin.bottom;
          const motiveHeight = Math.min(
            Math.max(
              styles.motive.minHeight,
              Math.min(estimatedLines, styles.motive.maxLines) * lineHeight +
                2 * styles.row.padding,
            ),
            maxMotiveHeight,
          );

          if (y < margin.bottom + motiveHeight) {
            page = addPage();
            y = pageHeight - margin.top - 20;
          }
          drawCell(
            page,
            motiveText,
            margin.left,
            y,
            tableWidth - 83,
            motiveHeight,
            {
              align: "left",
              fillColor: styles.motive.fill,
              textSize: styles.motive.text.size,
              textColor: styles.motive.text.color,
              isMotive: true,
            },
          );
          y -= motiveHeight;
        });

        // Dibujar fila de totales

        const totalRowData = {
          index: "",

          cite: "",

          name: "",

          program: "",

          location: "",

          dates: "",

          days: "",

          status: "TOTAL",

          allowance: totalAllowance
            ? `Bs. ${totalAllowance.toFixed(2)}`
            : "Bs. 0.00",

          tickets: totalTickets ? `Bs. ${totalTickets.toFixed(2)}` : "Bs. 0.00",
        };

        // Calcular altura necesaria para la fila de totales

        let totalRowHeight = styles.row.height;

        columns.forEach((col) => {
          const lines = totalRowData[col.key].split("\n").length;

          const textSize = col.size || styles.row.text.size;

          totalRowHeight = Math.max(
            totalRowHeight + 1,

            lines * (textSize + 2) + 2 * styles.row.padding,
          );
        });

        // Verificar espacio para la fila de totales

        if (y < margin.bottom + totalRowHeight) {
          page = addPage();

          y = pageHeight - margin.top - 20;
        }

        // Dibujar fila de totales

        const spanWidth = columns
          .slice(0, 8)
          .reduce((sum, col) => sum + col.width, 0);
        drawCell(page, "TOTAL", margin.left, y, spanWidth, totalRowHeight, {
          align: "center",
          fillColor: rgb(0.9, 0.9, 0.9),
          textSize: styles.row.text.size,
          textColor: styles.row.text.color,
          font: boldFont,
        });
        x = margin.left + spanWidth;
        drawCell(
          page,
          totalRowData.allowance,
          x,
          y,
          columns[8].width,
          totalRowHeight,
          {
            align: columns[8].align,
            fillColor: rgb(0.9, 0.9, 0.9),
            textSize: styles.row.text.size,
            textColor: styles.row.text.color,
          },
        );
        x += columns[8].width;
        drawCell(
          page,
          totalRowData.tickets,
          x,
          y,
          columns[9].width,
          totalRowHeight,
          {
            align: columns[9].align,
            fillColor: rgb(0.9, 0.9, 0.9),
            textSize: styles.row.text.size,
            textColor: styles.row.text.color,
          },
        );

        y -= totalRowHeight;

        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        // Abrir en nueva ventana
        const newWindow = window.open(url, "_blank");

        // Si el navegador bloquea la ventana emergente, ofrecer descarga alternativa
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          const link = document.createElement("a");
          link.href = url;
          link.download = `Reporte_Viaticos_${new Date()
            .toISOString()
            .slice(0, 10)}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.showSnackbar(
            "El navegador bloqueó la ventana emergente. Se descargará el PDF.",
            "info",
          );
        } else {
          // Limpiar el objeto URL después de que se carga la ventana
          newWindow.onload = () => URL.revokeObjectURL(url);
        }
        this.showSnackbar("PDF generado correctamente", "success");
      } catch (error) {
        console.error("Error al generar PDF:", error);
        this.showSnackbar("Error al generar PDF", "error");
      } finally {
        this.loading = false;
      }
    },

    // Función auxiliar para dibujar tablas
    // async drawTable(page, config, addPageWithBackground) {
    //   const {
    //     headers,
    //     rows,
    //     startX,
    //     startY,
    //     rowHeight,
    //     cellPadding,
    //     fontSize,
    //     font,
    //     headerFont,
    //     headerSize,
    //     headerColor,
    //     headerBgColor,
    //     alternateBgColor,
    //     borderColor,
    //     textColor,
    //     minRowHeight,
    //     margin,
    //   } = config;

    //   const colWidths = this.calculateColumnWidths(page, headers, rows);
    //   let y = startY;
    //   const pageWidth = 792; // Letter landscape (11x8.5 in)
    //   const pageHeight = 612;

    //   // Dibujar encabezados
    //   page.setFont(headerFont || font);
    //   page.setFontSize(headerSize || fontSize);
    //   headers.forEach((header, colIndex) => {
    //     if (colIndex != 11) {
    //       page.drawText(header, {
    //         x:
    //           startX +
    //           colWidths.slice(0, colIndex).reduce((a, b) => a + b, 0) +
    //           cellPadding,
    //         y: y - cellPadding,
    //         size: headerSize || fontSize,
    //         color: headerColor,
    //         maxWidth: colWidths[colIndex] - 2 * cellPadding,
    //       });
    //     }
    //   });

    //   y -= rowHeight;

    //   // Dibujar filas
    //   page.setFont(font);
    //   page.setFontSize(fontSize);

    //   rows.forEach((row, rowIndex) => {
    //     if (y < minRowHeight + margin) {
    //       // Nueva página si nos quedamos sin espacio
    //       page = addPageWithBackground();
    //       y = pageHeight - margin - rowHeight;
    //     }

    //     const bgColor = rowIndex % 2 === 0 ? rgb(1, 1, 1) : alternateBgColor;

    //     // Fondo de fila
    //     page.drawRectangle({
    //       x: startX,
    //       y: y - rowHeight,
    //       width: colWidths.reduce((a, b) => a + b, 0),
    //       height: rowHeight,
    //       color: bgColor,
    //       borderColor,
    //       borderWidth: 0.5,
    //     });

    //     // Contenido de celdas
    //     row.forEach((cell, colIndex) => {
    //       if (colIndex != 11) {
    //         page.drawText(cell, {
    //           x:
    //             startX +
    //             colWidths.slice(0, colIndex).reduce((a, b) => a + b, 0) +
    //             cellPadding,
    //           y: y - cellPadding,
    //           size: fontSize,
    //           color: textColor,
    //           maxWidth: colWidths[colIndex] - 2 * cellPadding,
    //           lineHeight: fontSize * 1.2,
    //         });
    //       }
    //     });

    //     y -= rowHeight;
    //   });

    //   return y;
    // },

    async fetchAsset(assetPath) {
      // Ruta relativa desde tu archivo JS/TS a la carpeta assets
      const response = await fetch(require(`@/assets/${assetPath}`));
      if (!response.ok) {
        throw new Error(`No se pudo cargar el recurso: /assets/${assetPath}`);
      }
      return await response.arrayBuffer();
    },

    loadImageFromAssets(filename) {
      return new Promise((resolve) => {
        try {
          const img = new Image();
          img.src = require(`@/assets/${filename}`);
          img.onload = () => resolve(img);
          img.onerror = () => resolve(null);
        } catch (e) {
          resolve(null);
        }
      });
    },
    calculateColumnWidths(page, headers, rows) {
      // Anchuras base (puedes ajustarlas según necesites)
      const baseWidths = {
        "N°": 15,
        AUTORIZACIÓN: 60,
        NOMBRE: 80,
        PROGRAMA: 70,
        "LUGAR/TRANSPORTE": 80,
        FECHAS: 60,
        DÍAS: 30,
        ESTADO: 50,
        VIÁTICOS: 50,
        PASAJES: 50,
      };

      // Si quieres cálculo dinámico basado en contenido:
      const dynamicWidths = headers.map((header) => {
        const allCellContents = [
          header,
          ...rows.map((row) => row[headers.indexOf(header)]),
        ];
        const maxLength = Math.max(
          ...allCellContents.map((text) => text?.length || 0),
        );
        return Math.min(maxLength * 5 + 20, 150); // Ajusta el factor según necesidad
      });

      // Usa anchuras base o dinámicas (aquí usamos base como ejemplo)
      return dynamicWidths.map((header) => baseWidths[header] || 60);
    },

    formatDatePdf(dateString) {
      if (!dateString) return "N/A\nN/A";

      try {
        const date = parseISO(dateString);
        if (isNaN(date.getTime())) return "N/A\nN/A";
        const datePart = format(date, "dd/MM/yyyy", { locale: es });
        const timePart = format(date, "HH:mm", { locale: es });
        return `${datePart}\n${timePart}`;
      } catch (error) {
        console.error("Error formateando fecha:", error);
        return "N/A\nN/A";
      }
    },

    formatDateExcel(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return isNaN(date.getTime())
        ? dateString
        : date.toLocaleDateString("es-ES");
    },

    shortenText(text, maxLength) {
      if (!text) return "N/A";
      return text.length > maxLength
        ? text.substring(0, maxLength - 3) + "..."
        : text;
    },

    getFormattedDate() {
      return format(new Date(), "yyyy-MM-dd");
    },

    handleError(context, error) {
      console.error(context, error);
      const message = this.extractErrorMessage(error);
      this.showSnackbar(message || "Ocurrió un error inesperado", "error");

      if (process.env.NODE_ENV === "production" && this.$sentry) {
        this.$sentry.captureException(error);
      }
    },

    extractErrorMessage(error) {
      if (error.response) {
        return (
          error.response.data.message || "Error en la respuesta del servidor"
        );
      }
      if (error.request) {
        return "No se recibió respuesta del servidor";
      }
      return error.message || "Error desconocido";
    },

    showSnackbar(message, color = "success") {
      this.$emit("show-snackbar", { message, color });
    },
  },
};
